<template>
	<div class="com-container">
		<div class="com-chart" ref="trend_ref"></div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
			chartInstane: null,
			allData: null, // 从服务器中获取的所有数据
			showChoice: false, // 是否显示可选项
			choiceType: "map", // 显示的数据类型
			titleFontSize: 0, // 指明标题的字体大小
		};
	},
	mounted() {
		this.initChart();
		this.getData();
		window.addEventListener("resize", this.screenAdapter);
		this.screenAdapter();
	},
	destroyed() {
		window.removeEventListener("resize", this.screenAdapter);
	},
	methods: {
		initChart() {
			this.chartInstane = this.$echarts.init(
				this.$refs.trend_ref,
				"chalk"
			);
			const initOption = {
				grid: {
					left: "8%",
					top: "25%",
					right: "8%",
					bottom: "5%",
					containLabel: true,
				},
				tooltip: {
					trigger: "axis",
				},
				legend: {
					left: 20,
					top: "5%",
					icon: "circle",
				},
        symbol:"circle",
				xAxis: {
					type: "category",
					boundaryGap: false,
          axisLabel:{
            color : "#fff"
          }
				},
				yAxis: {
					type: "value",
          axisLabel:{
            color : "#fff"
          }
				},
			};
			this.chartInstane.setOption(initOption);
		},
		async getData() {
			const { data: ret } = await axios.get(
				"/left-top"
			);
			this.allData = ret;
			this.updateChart();
		},
		updateChart() {
			// 处理数据
			// 类目轴的数据
			const timeArr = this.allData.xData
			// y轴的数据 series下的数据
			const seriesArr = {
          name: this.allData.name,
					type: "line",
					data: this.allData.yData,
          itemStyle:{
            color : 'rgba(0,184,220, 1)'
          },
					areaStyle: {
						color: new this.$echarts.graphic.LinearGradient(
							0,
							0,
							0,
							1,
							[
								{
									offset: 0,
									color: "rgba(0,184,220, 0.5)",
								}, // %0的颜色值
								{
									offset: 1,
									color: "rgba(0,184,220, 0)",
								}, // 100%的颜色值
							]
						),
					},
			};
			// 图例的数据
			const legendArr = [this.allData.name];
			const dataOption = {
				xAxis: {
					data: timeArr,
				},
				legend: {
					data: legendArr,
				},
				series: seriesArr,
			};
			this.chartInstane.setOption(dataOption);
		},
		screenAdapter() {
			this.titleFontSize = (this.$refs.trend_ref.offsetWidth / 100) * 3.6;
			const adapterOption = {
				legend: {
					itemWidth: this.titleFontSize/1.5,
					itemHeight: this.titleFontSize/1.5,
					itemGap: this.titleFontSize,
					textStyle: {
						fontSize: this.titleFontSize / 1.5,
            color:"#fff"
					},
				},
			};
			this.chartInstane.setOption(adapterOption);
			this.chartInstane.resize();
		},
	},
};
</script>

<style lang="less" scoped>
.title {
	position: absolute;
	left: 20px;
	top: 20px;
	z-index: 10;
	color: white;
}
</style>
